import React from "react";

import PropTypes from "prop-types";

function Tr({ className = "", children }) {
  return (
    <tr className={`border-b border-slate-700 group ${className}`}>
      {children}
    </tr>
  );
}

Tr.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Tr;
